var React = require('react');

function CustomizeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.9291 3.99878H3.47168L7.99999 15.9997C12.4183 15.9997 16 12.4178 16 7.99943C16 6.54195 15.6101 5.17565 14.9291 3.99878Z","fill":"#09A1E5","key":0}),React.createElement("path",{"d":"M1.07087 3.99878C0.389888 5.17565 0 6.54195 0 7.99943C0 12.4178 3.58175 15.9997 8.00002 15.9997V3.99878H1.07087Z","fill":"#FFD23B","key":1}),React.createElement("path",{"d":"M14.9287 3.9996C13.5453 1.60866 10.9603 0 7.99951 0L5.73535 4.00013L7.99951 8.00026L14.9287 3.9996Z","fill":"#FF3187","key":2}),React.createElement("path",{"d":"M7.99995 0C5.03911 0 2.45413 1.60866 1.0708 3.9996L7.99995 8.00026V0Z","fill":"#FF5178","key":3})]);
}

CustomizeInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CustomizeInline;

CustomizeInline.default = CustomizeInline;
